import { useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import { useEffect, useState } from "react";

import Form from "./details components/Form";
import { Loader, PageHeader } from "../../components";
import {
  objectFromResponseData,
  reminderObject,
} from "./details components/broadcastReminderObject";
import { useAxios, useComponent } from "../../hooks";

export default function BroadcastReminderDetails({ pageID }) {
  const axios = useAxios();
  const { broadcastID } = useParams();
  const { loader } = useComponent({ pageID });

  const [editState, setEditState] = useState(true);
  const [formData, setFormData] = useState(reminderObject);
  const { activeBot } = useSelector((state) => state.memberDetails);

  useEffect(() => {
    loader.start();
    if (broadcastID) {
      setEditState(false);
      axios({
        url: "/reminders/" + activeBot.ID + "?broadcast_id=" + broadcastID,
      }).then((response) => {
        if (response.status) {
          axios({
            url:
              "/wa/template/" + activeBot.ID + "?is_active=1&verified_status=3",
            method: "GET",
          }).then((resp) => {
            if (resp.status) {
              // setTemplate(resp.data.temp_obj);
              setFormData(
                objectFromResponseData(response.data, resp.data.temp_obj)
              );
            }
            loader.stop();
          });
        }
      });
    } else {
      loader.stop();
    }
  }, [axios, broadcastID, activeBot.ID, loader]);

  return (
    <Loader>
      <PageHeader title="Reminder Broadcast" pageName="Reminder Broadcast" />

      <Form
        formData={formData}
        editState={editState}
        setEditState={setEditState}
      />
    </Loader>
  );
}
